import { projectBidRowsListPageParamsSchemaValidator } from "@grafit/shared/utils/sidebar-url-params-schema";
import { createFileRoute } from "@tanstack/react-router";
import { BidRowListPage } from "../../../pages/bid-row-list-page/bid-row-list-page";

export const Route = createFileRoute("/_auth/_project/bid/$projectId/$subProjectId")({
  component: BidRowListPage,
  validateSearch: projectBidRowsListPageParamsSchemaValidator,
});
